import { observer } from "mobx-react"
import * as React from "react"
import Select from "react-select"
import { Badge, Button, Card, Form, Grid, Page, Tab, Table, Tabs } from "tabler-react"
import If from "../../components/if"

@observer
class PageForm extends React.Component {
    render() {
        const categorias = this.props.store.lancamentosByCategoria
        const categoriasIds = Object.keys(categorias)

        const tabLotacoes = (
            (this.props.store.lancamentos.length === 0) ? <h4>Nenhum lançamento encontrado.</h4> :
                (
                    <Tabs initialTab={categorias[categoriasIds[0]][0].categoria.descricao}>
                        {categoriasIds.map(categoriaId => {
                            const { categoria } = categorias[categoriaId][0]
                            return (
                                <Tab key={categoriaId} title={categoria.descricao}>
                                    <Table
                                        style={{
                                            display: 'block',
                                            overflowX: 'scroll',
                                            maxHeight: '50vh'
                                        }}
                                        className="table-lancamentos"
                                        responsive
                                        highlightRowOnHover
                                        hasOutline
                                        verticalAlign="center"
                                        cards>
                                        <Table.Header>
                                            <Table.Row>
                                                <If test={!this.props.store.processado && this.props.store.retificado}>
                                                    <Table.ColHeader>Situação</Table.ColHeader>
                                                </If>
                                                <Table.ColHeader>Matrícula</Table.ColHeader>
                                                <Table.ColHeader>CPF</Table.ColHeader>
                                                <th style={{ minWidth: '250px' }}>Nome</th>
                                                <If test={categoria.exibe_campos_agente_comunitario_saude}>
                                                    <th style={{ minWidth: '120px' }}>Afastamento</th>
                                                    <th style={{ minWidth: '120px' }}>Produção média</th>
                                                    <th style={{ minWidth: '120px' }}>Faltas não justificadas</th>
                                                    <th style={{ minWidth: '120px' }}>Cadastros</th>
                                                    <th style={{ minWidth: '120px' }}>Total Visitas</th>
                                                    <th style={{ minWidth: '120px' }}>Grupo</th>
                                                    <th style={{ minWidth: '120px' }}>Folgas</th>
                                                </If>
                                                <If test={!categoria.exibe_campos_agente_comunitario_saude}>
                                                    <If test={categoria.exibe_campo_vencimento_base}>
                                                        <Table.ColHeader>Vencimento base</Table.ColHeader>
                                                    </If>
                                                    <If test={categoria.exibe_campo_cargo}>
                                                        <Table.ColHeader>Valor cargo</Table.ColHeader>
                                                    </If>
                                                    <If test={categoria.exibe_campo_produtividade}>
                                                        <Table.ColHeader>Valor produção</Table.ColHeader>
                                                    </If>
                                                    <Table.ColHeader>Desconto(%)</Table.ColHeader>
                                                </If>
                                                <If test={this.props.store.processado}>
                                                    <th style={{ minWidth: '120px' }}>Compensado</th>
                                                    <th style={{ minWidth: '120px' }}>Valor GIP</th>
                                                </If>
                                                <If test={!this.props.store.processado}>
                                                    <Table.ColHeader>Ação</Table.ColHeader>
                                                </If>
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body>
                                            {categorias[categoriaId].map(lancamento => {
                                                return (
                                                    <If test={lancamento.visible} key={`row_${categoriaId}_${lancamento.lotacao_id}`}>
                                                        <Table.Row >
                                                            <If test={!this.props.store.processado && this.props.store.retificado}>
                                                                <Table.Col >
                                                                    <Badge color={lancamento.situacao_lotacao.badgeColor} className="mr-1">
                                                                        {lancamento.situacao_lotacao.badgeText}
                                                                    </Badge>
                                                                </Table.Col>
                                                            </If>
                                                            <Table.Col>{lancamento.matricula}</Table.Col>
                                                            <Table.Col className="text-nowrap">{lancamento.cpf}</Table.Col>
                                                            <Table.Col>{lancamento.colaborador.nome}</Table.Col>
                                                            <If test={categoria.exibe_campos_agente_comunitario_saude}>
                                                                <Table.Col>
                                                                    <Form.Select
                                                                        value={lancamento.afastamento}
                                                                        onChange={e => this.props.onChangeAfastamento(
                                                                            e.target.value,
                                                                            lancamento,
                                                                            this.props.store.competencia
                                                                        )}
                                                                        disabled={lancamento.remessa_id}
                                                                    >
                                                                        <option value="">Selecione</option>
                                                                        <option value="licenca">Licença</option>
                                                                        <option value="ferias">Férias</option>
                                                                    </Form.Select>
                                                                </Table.Col>
                                                                <Table.Col>
                                                                    <Form.Input
                                                                        type='text'
                                                                        value={lancamento.valor_producao_media}
                                                                        onChange={(e) => lancamento.setProducaoMedia(e.target.value)}
                                                                        placeholder='Produção'
                                                                        disabled={lancamento.remessa_id || !lancamento.afastamento}
                                                                    />
                                                                </Table.Col>
                                                                <Table.Col>
                                                                    <Form.Input
                                                                        type='text'
                                                                        value={lancamento.qtde_faltas_n_justificadas}
                                                                        onChange={(e) => lancamento.setQtdeFaltasNJustificadas(e.target.value)}
                                                                        placeholder='Faltas não justificadas'
                                                                        disabled={lancamento.remessa_id || lancamento.afastamento}
                                                                    />
                                                                </Table.Col>
                                                                <Table.Col>
                                                                    <Form.Input
                                                                        type='text'
                                                                        value={lancamento.qtde_cadastros_realizados}
                                                                        onChange={(e) => lancamento.setQtdeCadastrosRealizados(e.target.value)}
                                                                        placeholder='Cadastros'
                                                                        disabled={lancamento.remessa_id}
                                                                    />
                                                                </Table.Col>
                                                                <Table.Col>
                                                                    <Form.Input
                                                                        type='text'
                                                                        value={lancamento.qtde_visitas}
                                                                        onChange={(e) => lancamento.setQtdeVisitas(e.target.value)}
                                                                        placeholder='Total Visitas'
                                                                        disabled={lancamento.remessa_id || lancamento.afastamento}
                                                                    />
                                                                </Table.Col>
                                                                <Table.Col>
                                                                    <Form.Input
                                                                        type='text'
                                                                        value={lancamento.qtde_grupos}
                                                                        onChange={(e) => lancamento.setQtdeGrupos(e.target.value)}
                                                                        placeholder='Grupos'
                                                                        disabled={lancamento.remessa_id || lancamento.afastamento}
                                                                    />
                                                                </Table.Col>
                                                                <Table.Col>
                                                                    <Form.Input
                                                                        type='text'
                                                                        value={lancamento.qtde_folgas}
                                                                        onChange={(e) => lancamento.setQtdeFolgas(e.target.value)}
                                                                        placeholder='Folgas'
                                                                        disabled={lancamento.remessa_id || lancamento.afastamento}
                                                                    />
                                                                </Table.Col>
                                                            </If>
                                                            <If test={!categoria.exibe_campos_agente_comunitario_saude}>
                                                                <If test={categoria.exibe_campo_vencimento_base}>
                                                                    <Table.Col>{lancamento.valorVencimentoBase || '-'}</Table.Col>
                                                                </If>
                                                                <If test={categoria.exibe_campo_cargo}>
                                                                    <Table.Col>{lancamento.valorCargo}</Table.Col>
                                                                </If>
                                                                <If test={categoria.exibe_campo_produtividade}>
                                                                    <Table.Col className="">
                                                                        <Form.Input
                                                                            type='text'
                                                                            value={lancamento.valorProducao}
                                                                            onChange={(e) => lancamento.onChangeValorProducao(e.target.value)}
                                                                            placeholder='Valor produção'
                                                                            disabled={!this.props.liberaCampoProducao || lancamento.remessa_id}
                                                                        />
                                                                    </Table.Col>
                                                                </If>
                                                                <Table.Col className="lancamentos-col-input">
                                                                    <Form.Input
                                                                        type='text'
                                                                        value={lancamento.percentualDesconto}
                                                                        maxLength="6"
                                                                        onChange={(e) => lancamento.onChangePercentualDesconto(e.target.value)}
                                                                        placeholder='Desconto(%)'
                                                                        disabled={lancamento.remessa_id ? true : false}
                                                                    />
                                                                </Table.Col>
                                                            </If>
                                                            <If test={this.props.store.processado}>
                                                                <Table.Col>{lancamento.valorCompensado}</Table.Col>
                                                                <Table.Col>{lancamento.valorGipTotal}</Table.Col>
                                                            </If>
                                                            <If test={!this.props.store.processado}>
                                                                <Table.Col>
                                                                    <If test={lancamento.situacao_lotacao.updated}>
                                                                        <Button
                                                                            outline
                                                                            color="info"
                                                                            size="sm" className="ml-auto mb-2"
                                                                            onClick={() => this.props.visualizarLotacao(
                                                                                lancamento.lotacao_id,
                                                                                lancamento.situacao_lotacao.snapshot_atual,
                                                                                lancamento.situacao_lotacao.snapshot_anterior
                                                                            )}
                                                                        >
                                                                            Visualizar lotações
                                                                        </Button>
                                                                        <br />
                                                                    </If>
                                                                    <Button
                                                                        outline
                                                                        color="danger"
                                                                        size="sm" className="ml-auto"
                                                                        onClick={() => this.props.removerLancamento(
                                                                            lancamento.lotacao_id,
                                                                            lancamento.colaborador.nome
                                                                        )}
                                                                    >
                                                                        Remover
                                                                    </Button>
                                                                </Table.Col>
                                                            </If>
                                                        </Table.Row>
                                                    </If>
                                                )
                                            })}
                                        </Table.Body>
                                    </Table>
                                </Tab>
                            )

                        })}
                    </Tabs>
                )
        )

        const selectOrigem = (
            <Select
                closeMenuOnSelect={true}
                placeholder="Selecione uma origem"
                isClearable={true}
                options={this.props.store.origemSelect}
                onChange={options => this.props.onChangeOrigem(options)}
                value={this.props.store.origem}
                isDisabled={this.props.store.isEdit || this.props.store.competencia.length !== 6}
            >
            </Select>
        )

        return (
            <>
                <Page.Content>
                    <Page.Header>
                        <Page.Title>
                            Lançamentos
                        </Page.Title>
                    </Page.Header>
                </Page.Content>

                <Page.Card
                    footer={
                        <Card.Footer>
                            <div className="d-flex">
                                <Button link onClick={e => this.props.onBack()} type="button">Voltar</Button>
                                <If test={!this.props.store.disableBtnSalvar}>
                                    <Button
                                        color="primary"
                                        className="ml-auto"
                                        type="button"
                                        onClick={e => this.props.onSave()}
                                    >
                                        {this.props.store.isEdit ? 'Atualizar' : 'Salvar'}
                                    </Button>
                                </If>
                            </div>
                        </Card.Footer>
                    }
                >
                    <Grid.Row>

                        <Grid.Col md={2}>
                            <Form.Input
                                label='Competência'
                                type='text'
                                value={this.props.store.getCompetencia}
                                onChange={(e) => this.props.store.onChangeCompetencia(e.target.value)}
                                maxLength="7"
                                placeholder='AAAA/MM'
                                disabled={this.props.store.isEdit || this.props.store.origem}

                                feedback={this.props.store.wasValidated ? this.props.store.competenciaError : ''}
                                invalid={this.props.store.wasValidated && this.props.store.competenciaError}
                            />
                        </Grid.Col>

                        <Grid.Col md={10}>
                            <Form.Label>Origem</Form.Label>
                            {selectOrigem}
                        </Grid.Col>

                    </Grid.Row>

                    <h4>Lançamentos</h4>
                    <hr />

                    <If test={this.props.store.lancamentos.length !== 0}>
                        <If test={!this.props.store.processado}>
                            <Grid.Row>
                                <Grid.Col md={2}>
                                    <Form.Input
                                        label="Adicionar lançamento"
                                        type='text'
                                        value={this.props.store.matriculaSearch}
                                        onChange={(e) => this.props.store.onChangeMatricula(e.target.value)}
                                        placeholder='Digite a matrícula'
                                    />
                                </Grid.Col>
                                <Grid.Col md={2}>
                                    <label className="form-label">&nbsp;</label>
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={e => this.props.addLotacao()}>
                                        Adicionar
                                    </Button>
                                </Grid.Col>
                            </Grid.Row>
                        </If>
                        <Grid.Row>
                            <Grid.Col md={9}>
                                <Form.Input
                                    label="Filtrar lançamentos"
                                    type='text'
                                    value={this.props.store.filtroLancamentos}
                                    onChange={(e) => this.props.store.onChangeFiltroLancamento(e.target.value)}
                                    placeholder='Digite a matrícula, CPF ou o nome para pesquisar'
                                />
                            </Grid.Col>
                        </Grid.Row>
                    </If>

                    <Grid.Row>
                        <Grid.Col md={12} className="text-center">
                            {tabLotacoes}
                        </Grid.Col>
                    </Grid.Row>

                </Page.Card>
            </>
        )
    }
}

export default PageForm